import { useEffect, useState } from 'react';
import { ButtonIcon, FlexContainer, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { ZOOM } from '../../state/constants';
import { EmptyData } from '../emptyData';
import { ImageViewer } from '../imageViewer';
import {
  StyledModalImageFooter,
  StyledModalImageHeader,
  StyledModalImageSource,
  StyledModalImageStyles,
  StyledModalImageZoom,
} from './Styles';

type Props = {
  onGoLeft?(): void;
  onGoRight?(): void;
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  show?: boolean;
  onChangeShow(show: boolean): void;
  testId?: string;
  className?: string;
  disabled?: boolean;
  disabledGoLeft?: boolean;
  disabledGoRight?: boolean;
  image: string;
};

export const ModalImageDetail = ({
  show = false,
  onChangeShow,
  testId,
  className,
  onGoRight,
  onGoLeft,
  title,
  subtitle,
  disabledGoLeft,
  disabledGoRight,
  image,
}: Props) => {
  const { t } = useTranslation();

  const [zoom, setZoom] = useState<number>(ZOOM.defaultZoom);
  const [innerShow, setInnerShow] = useState<boolean>(show);

  useEffect(() => {
    setInnerShow(show);
  }, [show]);

  const onCloseModal = () => {
    setInnerShow(false);
  };

  const increaseZoom = () => {
    setZoom(zoom + ZOOM.defaultScale);
  };

  const decreaseZoom = () => {
    setZoom(zoom - ZOOM.defaultScale);
  };

  return (
    <StyledModalImageStyles
      testId={testId}
      className={className}
      onChangeShow={onChangeShow}
      show={innerShow}
    >
      <>
        <StyledModalImageHeader
          alignItems="center"
          justifyContent="space-between"
        >
          <FlexContainer columnGap="1.6" alignItems="center" flex="1">
            <ButtonIcon
              iconName="ArrowArcLeft"
              onClick={onCloseModal}
              variant="secondary"
            />
            <Label fontSize="14" semibold negative noWrap>
              {`${t(title)} ${subtitle || ''}`}
            </Label>
          </FlexContainer>
          <FlexContainer columnGap="1.6" flex="1" justifyContent="center">
            <ButtonIcon
              iconName="MagnifyingGlassMinus"
              onClick={decreaseZoom}
              disabled={zoom === ZOOM.minZoom}
              variant="secondary"
            />
            <StyledModalImageZoom fontSize="12" negative>
              {Number(zoom * 100)}%
            </StyledModalImageZoom>
            <ButtonIcon
              iconName="MagnifyingGlassPlus"
              onClick={increaseZoom}
              disabled={zoom === ZOOM.maxZoom}
              variant="secondary"
            />
          </FlexContainer>
          {/* nav buttons between files  */}
          <FlexContainer columnGap="1.6" flex="1">
            <span />
          </FlexContainer>
          {/* nav buttons between files  */}
        </StyledModalImageHeader>
        {image ? (
          <StyledModalImageSource>
            <ImageViewer url={image} zoom={zoom} />{' '}
          </StyledModalImageSource>
        ) : (
          <EmptyData />
        )}
        <StyledModalImageFooter
          alignItems="center"
          justifyContent="center"
          columnGap="1.6"
        >
          {onGoLeft && onGoRight && (
            <>
              <ButtonIcon
                iconName="ArrowCircleLeft"
                onClick={onGoLeft}
                variant="secondary"
                disabled={disabledGoLeft}
              />
              <ButtonIcon
                iconName="ArrowCircleRight"
                onClick={onGoRight}
                variant="secondary"
                disabled={disabledGoRight}
              />
            </>
          )}
        </StyledModalImageFooter>
      </>
    </StyledModalImageStyles>
  );
};
